import React, { useState } from "react";
import {
  Card,
  CardActionArea,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { ReactComponent as DocIcon } from "../../../image/singlepagedescriptionvector/docicon.svg";

const useStyles = makeStyles((theme) => ({
  containerfluid: {
    width: "100%",
  },
  container: {
    [theme.breakpoints.down("xs")]: {
      padding: "0",
      margin: "0",
    },

    "& .MuiCardActionArea-root": {
      padding: "1rem",
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down("xs")]: {
      padding: "0.5rem",
      },
      "& .MuiTypography-h4": {
        fontSize: "0.875rem ",
        fontWeight: "600",
        color: "#000",
        fontFamily: "'Playfair Display', serif !important",
        marginBottom: "0.6rem",
        [theme.breakpoints.down("xs")]: {
          fontSize: "1rem",
        },
      },
      "& .MuiTypography-caption": {
        fontSize: "0.75rem",
        fontWeight: "400",
        color: "#9A9A9A",
        fontFamily: "'Jost', serif !important",
        marginLeft: "0.3rem",
        [theme.breakpoints.down("xs")]: {
          fontSize: "0.8rem",
        },
      },
    },
  },
  secheadhr: {
    width: "175px",
    marginTop: "15px",
    backgroundImage: "linear-gradient(90deg, #FF8008 0%, #FFC837 100%)",
    border: "0",
    height: "3px",
    [theme.breakpoints.down("xs")]: {
      marginTop: "0.6rem",
      marginBottom: "0rem",
    },
  },
  headingsection: {
    marginBottom: "2rem",
    "& .MuiTypography-h3": {
      fontFamily: "'Playfair Display', serif !important",
      fontSize: "3rem",
      color: "#252525",
      fontWeight: "700",
      margin: "0",
      [theme.breakpoints.down("xs")]: {
        fontSize: "1.5rem",
        lineHeight: " 40px",
        fontFamily: "'Playfair Display', serif !important",
      },
    },
    "& .MuiTypography-h5": {
      fontFamily: "'Playfair Display', serif !important",
      fontSize: "1.5rem",
      margin: "0",
      color: "#252525",
      fontWeight: "500",
      [theme.breakpoints.down("xs")]: {
        fontSize: "0.75rem",
        margin: "0",
        color: "#252525",
        fontWeight: "400",
      },
    },
  },
  innercontainer: {
    background: "white",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.11)",
    padding: "2rem",
    marginBottom: "2rem",
    [theme.breakpoints.down("xs")]: {
      padding: "0.8rem",
    },
    "& .MuiTypography-h6": {
      fontSize: "1.25rem !important",
      fontWeight: "700",
      color: "#000",
      fontFamily: "'Playfair Display', serif !important",
      [theme.breakpoints.down("xs")]: {
        fontSize: "0.875rem !important",
      },
    },
  },
  cardcontainer: {
    display: "flex",
    flexWrap: "wrap",
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
  },
  card: {
    background: "white",
    borderRadius: "8px",
    marginTop: "1rem",
    marginRight: "1rem",
    width: "23%",
    margin: "1rem 0",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    transition: "all ease 0.2s",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0px 10px 10px 2px rgba(0, 0, 0, 0.25)",
      cursor: "pointer",
    },
  },
  cardimage: {
    width: "25%",
    [theme.breakpoints.down("xs")]: {
      width: "37%",
    },
  },
  carddescription: {
    width: "75%",
    [theme.breakpoints.down("xs")]: {
      width: "63%",
    },
  },
  // modalcontainer: {
  //   position: "absolute",
  // },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  iconandcaption: {
    display: "flex",
    alignItems: "center",
    "& svg": {
      [theme.breakpoints.down("xs")]: {
        width: "7px",
      },
    },
  },
}));
function BundleInSitesSection({ data, testseriesDetail }) {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  const handleOpenClose = () => {
    setOpen(!open);
  };

  return (
    <div className={classes.containerfluid}>
      <div className={classes.container}>
        <div className={classes.headingsection}>
          <Typography variant="h3" gutterBottom>
            Bundle In-Sites ( {testseriesDetail?.test_series_count} Test Series
            )
          </Typography>
          <Typography variant="h5" gutterBottom>
            Test Series Included in this Bundle
          </Typography>
          <hr align="left" className={classes.secheadhr} />
        </div>

        <div className={classes.innercontainer}>
          {data.map((bundle, bundleIndex) =>
            bundle.mocks.length > 0 ? (
              <div key={bundleIndex}>
                <Typography variant="h6" gutterBottom>
                  {bundle.exam_name}
                </Typography>
                <div className={classes.cardcontainer}>
                  {bundle.mocks.map((mock, mockIndex) => (
                    <Card className={classes.card} key={mockIndex}>
                      <CardActionArea onClick={handleOpenClose}>
                        <div className={classes.cardimage}>
                          <img
                            src={mock.image_url}
                            alt="logo"
                            style={{ height: "70%", width: "70%" }}
                          />
                        </div>
                        <div className={classes.carddescription}>
                          <Typography variant="h4">
                            {mock.test_series_name}
                          </Typography>
                          <div className={classes.iconandcaption}>
                            <DocIcon />
                            <Typography variant="caption">
                              {mock?.question_count} Question {mock?.duration} Min
                            </Typography>
                          </div>
                        </div>
                      </CardActionArea>
                    </Card>
                  ))}
                </div>
              </div>
            ) : null
          )}
        </div>
        <div></div>
        {/* <div className={classes.innercontainer}>
          <Typography variant="h6" gutterBottom>
            Sectional Mocks
          </Typography>
          <div className={classes.cardcontainer}>
            <Card className={classes.card}>
              <CardActionArea onClick={handleOpenClose}>
                <div className={classes.cardimage}>
                  <img src={SSCLogo} alt="logo" />
                </div>
                <div className={classes.carddescription}>
                  <Typography variant="h4">
                    Basic Computer Knowledge Subject test (Bilingual ) By
                    ParikshaDo
                  </Typography>

                  <div className={classes.iconandcaption}>
                    <DocIcon />
                    <Typography variant="caption">5 Mock Tests</Typography>
                  </div>
                </div>
              </CardActionArea>
            </Card>
            <Card className={classes.card}>
              <CardActionArea onClick={handleOpenClose}>
                <div className={classes.cardimage}>
                  <img src={SSCLogo} alt="logo" />
                </div>
                <div className={classes.carddescription}>
                  <Typography variant="h4">
                    Basic Computer Knowledge Subject test (Bilingual ) By
                    ParikshaDo
                  </Typography>

                  <div className={classes.iconandcaption}>
                    <DocIcon />
                    <Typography variant="caption">5 Mock Tests</Typography>
                  </div>
                </div>
              </CardActionArea>
            </Card>
            <Card className={classes.card}>
              <CardActionArea onClick={handleOpenClose}>
                <div className={classes.cardimage}>
                  <img src={SSCLogo} alt="logo" />
                </div>
                <div className={classes.carddescription}>
                  <Typography variant="h4">
                    Basic Computer Knowledge Subject test (Bilingual ) By
                    ParikshaDo
                  </Typography>

                  <div className={classes.iconandcaption}>
                    <DocIcon />
                    <Typography variant="caption">5 Mock Tests</Typography>
                  </div>
                </div>
              </CardActionArea>
            </Card>
          </div>
        </div>
        <div className={classes.innercontainer}>
          <Typography variant="h6" gutterBottom>
            Topic-wise Mocks
          </Typography>
          <div className={classes.cardcontainer}>
            <Card className={classes.card}>
              <CardActionArea onClick={handleOpenClose}>
                <div className={classes.cardimage}>
                  <img src={SSCLogo} alt="logo" />
                </div>
                <div className={classes.carddescription}>
                  <Typography variant="h4">
                    Basic Computer Knowledge Subject test (Bilingual ) By
                    ParikshaDo
                  </Typography>

                  <div className={classes.iconandcaption}>
                    <DocIcon />
                    <Typography variant="caption">5 Mock Tests</Typography>
                  </div>
                </div>
              </CardActionArea>
            </Card>
            <Card className={classes.card}>
              <CardActionArea onClick={handleOpenClose}>
                <div className={classes.cardimage}>
                  <img src={SSCLogo} alt="logo" />
                </div>
                <div className={classes.carddescription}>
                  <Typography variant="h4">
                    Basic Computer Knowledge Subject test (Bilingual ) By
                    ParikshaDo
                  </Typography>

                  <div className={classes.iconandcaption}>
                    <DocIcon />
                    <Typography variant="caption">5 Mock Tests</Typography>
                  </div>
                </div>
              </CardActionArea>
            </Card>
            <Card className={classes.card}>
              <CardActionArea onClick={handleOpenClose}>
                <div className={classes.cardimage}>
                  <img src={SSCLogo} alt="logo" />
                </div>
                <div className={classes.carddescription}>
                  <Typography variant="h4">
                    Basic Computer Knowledge Subject test (Bilingual ) By
                    ParikshaDo
                  </Typography>

                  <div className={classes.iconandcaption}>
                    <DocIcon />
                    <Typography variant="caption">5 Mock Tests</Typography>
                  </div>
                </div>
              </CardActionArea>
            </Card>
          </div>
        </div>
        <div className={classes.modalcontainer}>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={open}
            onClose={handleOpenClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <MocksPopup handleOpenClose={handleOpenClose} open={open} />
          </Modal>
        </div> */}
      </div>
    </div>
  );
}
export default BundleInSitesSection;
